import { render, staticRenderFns } from "./FormCreateTable.vue?vue&type=template&id=060f3162&"
import script from "./FormCreateTable.vue?vue&type=script&lang=js&"
export * from "./FormCreateTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports